import { Product } from "@/types/dtos/products";
import { useMemo } from "react";

const useCampaignText = (product: Product) => {
  const getRepresentableTexts = useMemo(() => {
    const { campaignItems } = product || {};
    const texts = campaignItems?.map((campaign) => campaign.representableTexts);
    return texts || [];
  }, [product]);

  return { getRepresentableTexts };
};

export default useCampaignText;
